import React from 'react';
import './Button.scss';
import { getPrefixedDataAttributes } from '@/components/utils/DomUtils';
import { buttonDisabledStyles } from '@/components/utils/DefaultStyles';
import type { IButtonProps } from '@/components/utils/Interfaces';
import Icon from '@/components/Icon/Icon';
import { resolveAssetUrl } from '@/utilities/CommonUtils';

/** Button is a clickable interactive element that triggers a response. You can place text and icons inside of a button. */
const Button: React.FC<IButtonProps> = ({ ...props }) => {
  const {
    className,
    disabled,
    iconClassName,
    iconOnLeftSrc,
    labelClassName,
    children,
    iconOnRightSrc,
    dataAttributes,
    onClick,
    id,
    isReactIcon = false,
    isDataLoading = false,
  } = props;

  const styles = disabled ? { ...props.style, ...buttonDisabledStyles } : props.style;

  return (
    <button
      className={className}
      style={styles}
      type="button"
      id={id}
      disabled={disabled}
      onClick={(e) => onClick && onClick(e)}
      {...getPrefixedDataAttributes(dataAttributes, 'Button')}
    >
      {iconOnLeftSrc && (
        <span className={`${iconClassName} btn-left-icon-container`}>
          {!isReactIcon && <img alt="icon" loading="lazy" src={resolveAssetUrl(iconOnLeftSrc)} />}
          {isReactIcon && <Icon source={iconOnLeftSrc} />}
        </span>
      )}
      {children && <span className={labelClassName}>{children}</span>}
      {iconOnRightSrc && !isDataLoading && (
        <span className={`${iconClassName} btn-right-icon-container`}>
          {!isReactIcon && <img alt="icon" loading="lazy" src={resolveAssetUrl(iconOnRightSrc)} />}
          {isReactIcon && <Icon source={iconOnRightSrc} />}
        </span>
      )}

      {isDataLoading && (
        <span className="wave position-relative">
          <span className="dot" />
          <span className="dot" />
          <span className="dot" />
        </span>
      )}
    </button>
  );
};

Button.displayName = 'Button';

export default Button;
